import styled from "styled-components";
import colors from "../../../assets/styles/colors";
import ReactTooltip from 'react-tooltip';

export const ResultForm = styled.form``;

export const ResultFormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  margin-top: 30px;
`;

export const ResultFormRowBorder = styled.div`
  border: 2px solid #DDDDDD;
  border-radius: 9px;
  margin-bottom: 30px;
  height: 100%;
`;

export const ResultButtonArea = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ResultContent = styled.div`
  border-radius: 8px;
  border: 2px solid ${colors.grayLight};
`;

export const ResultColumn = styled.div`

`;

export const ResultResultItem = styled.div`
  padding: 20px;
  display: flex;
`;

export const ResultHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px; /* Relleno de 10px en la parte superior */
  padding-right: 20px; /* Relleno de 20px a la derecha */
  padding-bottom: 0px; /* Relleno de 15px en la parte inferior */
  padding-left: 20px;
`;

export const ResultHeaderInfo = styled.div`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const ResultResultItemIcon = styled.div`
  width: 47px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.background};
  border-radius: 8px;
  margin-right: 15px;
`;

export const ResultResultItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ResultDisplayResultLabel = styled.h6`
  color: ${colors.bgPrimary};
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
`;

export const ResultDisplayValues = styled.div`
  margin: 30px 0;
`;

export const ResultDisplayValuesRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;

  &:first-child {
    margin-top: 0;
  }

  span:last-child {
    font-weight: 700;
  }
`;

export const ResultDisplayValuesRowValue = styled.span`
  font-size: 14px;
  line-height: 23px;
  color:${colors.textPrimary};
`;

export const ResultFooter = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;


export const ResultFooterLeftSide = styled.div``;

export const ResultFooterRightSide = styled.div`
  display: flex;
`;


export const TooltipTitle = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
`;

export const TooltipContent = styled.div`
font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.03em;
`;

export const Tooltip = styled(ReactTooltip).attrs({
  className: "custom-tooltip",
})`
  &.custom-tooltip {
    width: 300px !important;
    padding: 13px !important;
    font-family: Montserrat !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 22px !important;
    letter-spacing: 0.03em !important;
    opacity: 1 !important;
    background-color: rgb(187, 215, 212);
  }
`;

export const InfoCircleImage = styled.img`
  margin-bottom:-3px;
  margin-left: 3px;
`;  
